import { makeStyles } from '@material-ui/styles'

export default makeStyles((theme) => ({
  link: {
    cursor: 'pointer',
    textDecoration: 'underline',
    color: theme.palette.web.blue
  }
}))
